import { render, staticRenderFns } from "./PurchaseDetail.vue?vue&type=template&id=2893ed8c&scoped=true"
import script from "./PurchaseDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2893ed8c",
  null
  
)

export default component.exports